import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "js-page-content",
  role: "main",
  class: "page-content"
}
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-xl-12" }
const _hoisted_4 = {
  id: "panel-1",
  class: "panel"
}
const _hoisted_5 = {
  class: "panel-container show",
  id: "panel-search"
}
const _hoisted_6 = { class: "panel-content contents" }
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { class: "col-md-11 contCnt selectedClear" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_vSelect = _resolveComponent("vSelect")!

  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _cache[4] || (_cache[4] = _createElementVNode("div", { class: "row" }, [
      _createElementVNode("div", { class: "subheader col-6" }, [
        _createElementVNode("h1", { class: "subheader-title" }, "請求書NR取得")
      ]),
      _createElementVNode("div", { class: "subheader-block ml-auto demo" })
    ], -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _cache[3] || (_cache[3] = _createElementVNode("div", { class: "panel-hdr" }, [
            _createElementVNode("h2", null, "NR取得"),
            _createElementVNode("div", { class: "panel-toolbar" }, [
              _createElementVNode("button", {
                class: "btn btn-panel",
                "data-action": "panel-collapse",
                "data-toggle": "tooltip",
                "data-offset": "0,10",
                "data-original-title": "Collapse"
              }),
              _createElementVNode("button", {
                class: "btn btn-panel",
                "data-action": "panel-fullscreen",
                "data-toggle": "tooltip",
                "data-offset": "0,10",
                "data-original-title": "Fullscreen"
              })
            ])
          ], -1)),
          _createElementVNode("div", _hoisted_5, [
            _cache[2] || (_cache[2] = _createElementVNode("div", { class: "loader" }, [
              _createElementVNode("i", { class: "fal fa-spinner-third fa-spin-4x fs-xxl" })
            ], -1)),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _cache[0] || (_cache[0] = _createElementVNode("div", { class: "col-md-1 contTitle" }, "案件番号", -1)),
                _createElementVNode("div", _hoisted_8, [
                  _createVNode(_component_vSelect, { options: _ctx.opProjectNumber }, null, 8, ["options"])
                ])
              ]),
              _cache[1] || (_cache[1] = _createStaticVNode("<div class=\"row\"><div class=\"col-md-1 contTitle\">請求番号</div><div class=\"col-md-11 contTitle\">メモ</div></div><div class=\"row\"><div class=\"col-md-1 contTitle\"><input type=\"text\" class=\"form-control form-control-sm\" maxlength=\"10\" disabled></div><div class=\"col-md-11 contCnt\"><input type=\"text\" class=\"form-control form-control-sm\"></div></div><div class=\"row mt-5 ml-auto\"><button type=\"button\" class=\"btn btn-secondary waves-effect waves-themed\"> 請求番号欄追加 </button></div>", 3))
            ])
          ])
        ])
      ])
    ])
  ]))
}